import { startsWith } from 'lodash';

import {
  EAttributeType,
  ICreateCustomDimensionPayload,
  IUpdateCustomDimensionPayload,
} from '@src/emp-3.0/types';

export const trimCustomDimensionPayloadMappedEventNames = (
  data: ICreateCustomDimensionPayload | IUpdateCustomDimensionPayload = {
    attribute_name: '',
    display_name: '',
    category: 'custom',
    mapped_event_names: [],
    attribute_type: EAttributeType.Global,
  },
) => {
  const { mapped_event_names } = data;
  const filteredArray: string[] = mapped_event_names.filter((name: string) => name !== '');
  return {
    ...data,
    mapped_event_names: filteredArray,
  };
};

export function trimStartPrefix(text: string, prefix: string = '__global__'): string {
  if (startsWith(text, prefix)) {
    return text.substring(prefix.length);
  }
  return text;
}
